import autosize from 'autosize'

export default {
  inserted(el, binding, vnode, oldVnode) {
    autosize(el)

    el.onResize = function () {
      autosize.update(el)
    }
    window.addEventListener('onresize', el.onResize)
  },
  update(el, binding, vnode, oldVnode) {
    autosize.update(el)
  },
  componentUpdated(el, binding, vnode, oldVnode) {
    autosize.update(el)
  },
  unbind(el) {
    window.removeEventListener('onresize', el.onResize)
  },
}
